import React from 'react';
import type OpsTeamAutomationType from '@atlassian/jira-spa-apps-ops-team-scope-automation/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyOpsTeamAutomation = lazyForPaint<typeof OpsTeamAutomationType>(
	() =>
		import(
			/* webpackChunkName: "async-ops-team-scope-automation", jiraSpaEntry: "async-ops-team-scope-automation" */ '@atlassian/jira-spa-apps-ops-team-scope-automation'
		),
);

const AsyncOpsTeamAutomation = (): React.JSX.Element => (
	<LazyPage Page={LazyOpsTeamAutomation} pageId="ops-team-automation" shouldShowSpinner />
);

export default AsyncOpsTeamAutomation;
